/* **********************************************************************************************************
**** showPage2DataTransformationService : service written to transform the data to fit in ui2.0 layout ******
********************************************************************************************************** */

/********** Button type mapping and button position info  *****
 1: workflow button , btn pos : 10
 2 : nonworkflow button, btn pos : 20
 3: systemworkflow button, btn pos : 10
 4 : additionalcreate button, btn pos : 10
 5 : save comment and attachment button, btn pos :30

 10: top row
 20 : nwf button position
 30 : save comment attchment button position
 *****************************************************************/
(function(){
angular.module('ui2.0Service')
    .factory('showPage2DataTransformationService', ['showPageBtnClickService','showPageService','formService','showPageTabInfo','$timeout','$routeParams','advSearchService','$rootScope','delegationService','$location','dataManipulationService', function ($showPageBtnClickService,$showPageService,$formService,showPageTabInfo,$timeout,$routeParams,advSearchService,$rootScope,delegationService,$location,dataManipulationService) {
    var returnObj={'leftTabInfo':[],'rightTabInfo':[]},leftTabList,allleftTabInfo,selectedTabObj,selectedTabIndex;
    /*var entityTypeIdArr = [61,1,12,13 ];*/
    var entityTypeIdArr = [1,3,12,13,14,15,16,17,18,61,64,67,80,86,87,138,139,140,160,165,176,181,28,63,316,366];

    return {
        separateLeftRightTabs: separateLeftRightTabs,
        separateButtons: separateButtons,
        btnClick: btnClick,
        setVisiblityOfDocTree:setVisiblityOfDocTree,
        toggleDocTreeVisibilitySession: toggleDocTreeVisibilitySession,
        separateSearchTableFieldInfo: separateSearchTableFieldInfo,
        getBtnClass : getBtnClass,
        btnClassObj : {1:'btn-wf',2:'btn-nwf',3:'btn-sys-wf',4:'btn-add-CB'},
        returnObj:returnObj,
        createGroupOfFields : createGroupOfFields,
        hideNonReqFields : hideNonReqFields,
        hideButtonForWorkspaceView:hideButtonForWorkspaceView,
        toggleBrowserStorageObjVal: toggleBrowserStorageObjVal,
        validateDynamicForm: validateDynamicForm,
        mountAnalyticsTab: mountAnalyticsTab,
        shouldShowPerformance,
        /*leftTabList : leftTabList,
        leftTabInfo:leftTabInfo,
        allleftTabInfo:allleftTabInfo,
        selectedTabObj:selectedTabObj*/
    };

    /*****************|| BEGINNING OF PUBLIC FUNCTIONS || *********************/
    /**separateLeftRightTabs : function to separate tabs for left and right section **/
    function separateLeftRightTabs(tabfields, entityTypeIdVal,separateOnUi,showInWorkspace) {
        const sc = this;
        //@todo this will be removed after implemnetation of new ae showpage
        if(window.location.href.indexOf("autoExtraction/document") !== -1){
           tabfields.forEach((tab) => {
                if(tab.id == 4323){
                    tab.alignment = 'left';
                }
           })
        }
        var tabfields = angular.copy(tabfields);
        returnObj.viewerTabInfo = [];
        returnObj.uploadTabInfo = [];
        if( !separateOnUi && entityTypeIdArr.indexOf( entityTypeIdVal ) != -1 && !showInWorkspace){
            returnObj.leftTabInfo = _.filter(tabfields,function(o){
                if(!o.alignment){
                    o.alignment = 'left';//Assigning by default.
                }
                //@todo last two ids will be removed after implementation of new ae showpage
                if([3557, 3562, 3,4588, 4589].includes(o.id)) return false;
                return o.alignment == 'left';
            });
            returnObj.uploadTabInfo = _.filter(tabfields,function(o){return (o.id==3);});
            returnObj.viewerTabInfo = _.filter(tabfields,function(o){return (o.id==3557 || o.id==3562);});
            returnObj.rightTabInfo = _.filter(tabfields,function(o){return o.alignment == 'right';});
        }else if(showInWorkspace){
            returnObj.leftTabInfo=_.filter(tabfields,function(o){
                if(!o.alignment){
                    o.alignment = 'left';//Assigning by default.
                }
                return o.alignment == 'left' && o.type == 'basic';
            });
            returnObj.rightTabInfo = _.filter(tabfields,function(o){
                return o.alignment == 'right';
            });
        }
        else {
            returnObj.leftTabInfo = [];
            returnObj.rightTabInfo = [];
            for (var i = 0; i < tabfields.length; i++) {
                if(!showPageTabInfo[entityTypeIdVal]){
                    returnObj.leftTabInfo.push(tabfields[i]);
                } else{
                    if (showPageTabInfo[entityTypeIdVal].rightTab.indexOf(tabfields[i].id.toString()) > -1) {
                        if(showPageTabInfo[entityTypeIdVal].tabEntityMap && showPageTabInfo[entityTypeIdVal].tabEntityMap[tabfields[i].id]){
                            tabfields[i].styleClass = ("entity_"+  showPageTabInfo[entityTypeIdVal].tabEntityMap[tabfields[i].id]);
                            tabfields[i].shortName = showPageTabInfo[entityTypeIdVal].tabEntityShortName[tabfields[i].id];
                        }
                        returnObj.rightTabInfo.push(tabfields[i]);
                    } else {
                        returnObj.leftTabInfo.push(tabfields[i]);
                    }
                }

            }

        }
        if("bulkAction" != this.pageType && 'delegationCreate' != this.pageType)
            separateCommentData.call(this,entityTypeIdVal,separateOnUi,sc);
        else{
          //  returnObj.leftTabInfo[0]["type"] = "tabs";
            returnObj.selectedTabObj = returnObj.leftTabInfo[0];
            returnObj.selectedTabIndex = 0;
            returnObj.allleftTabInfo = angular.copy(returnObj.leftTabInfo);

            if(this.pageType=='delegationCreate'){
                delegationService.selectedTab = returnObj.allleftTabInfo[0];
                delegationService.allleftTabInfo = returnObj.allleftTabInfo;
                getTabLabel.call(this,returnObj.allleftTabInfo);
            }
        }
        if(  SirionUtils.isArray(returnObj.rightTabInfo) &&  returnObj.rightTabInfo.length >0  ){
            checkCommTabAdditionalFields.call(this,returnObj.rightTabInfo,separateOnUi);
        }
    }
    /********************************** End of separateLeftRightTabs function ****************************/

    /**separateCommentData : function to separate comment layout **/
    function separateCommentData(entityTypeIdVal,separateOnUi, sc) {
        var self = this;
        if((separateOnUi) || entityTypeIdArr.indexOf(entityTypeIdVal) == -1  || (entityTypeIdArr.indexOf(entityTypeIdVal) > -1  && (self.pageType=='clone' || self.isClonePage))) {
            var commentsData = _.filter(returnObj.leftTabInfo[0].fields, function (o) {
                return o.id == '40';
            });
            //if (self.header.response.type != 'popUp' && commentsData.length) {

            returnObj.leftTabInfo[0].fields = _.filter(returnObj.leftTabInfo[0].fields, function (o) {
                return o.id != '40';
            });
            if (commentsData.length) {
                sc.checkCommentRightSection(!!commentsData);
                commentsData[0].fields = reorderCommentField(commentsData[0].fields);
            }

            if (!returnObj.rightTabInfo.length && commentsData.length) {
                returnObj.rightTabInfo.push({'fields': [], 'label': intl_msg[23348]||'communication','type':'communicationTab'});
            }
            if (!this.docViewerPage && returnObj.rightTabInfo.length) {
                if(commentsData.length){
                    returnObj.rightTabInfo[0].fields.unshift(commentsData[0]);
                }
                returnObj.rightTabInfo[0].type = 'communicationTab' ;
            }

        }
        self.tempCommentData = angular.copy(self.data.comment);
        returnObj.allleftTabInfo = angular.copy(returnObj.leftTabInfo);

        /*let extraTab = angular.copy(returnObj.allleftTabInfo[returnObj.allleftTabInfo.length - 1]);
        extraTab.id = 4444;
        extraTab.properties.lineItem = true;
        extraTab.type = 'grip';
        delete extraTab.properties.selectStyle;
        returnObj.allleftTabInfo.splice(returnObj.allleftTabInfo.length -1, 0, extraTab);*/


        //if($routeParams.action == 'show'){
        if(self.pageType=='show'){
            returnObj.leftTabInfo = selectDefaultTabs(returnObj.leftTabInfo);
            if(returnObj.allleftTabInfo.length){
                returnObj.leftTabList = _.differenceBy(returnObj.allleftTabInfo, returnObj.leftTabInfo, 'id');
            }
        }else{
            returnObj.leftTabList = [];
        }
        if(  SirionUtils.isArray(returnObj.rightTabInfo) &&  returnObj.rightTabInfo.length >0  ){
            checkCommTabAdditionalFields.call(this,returnObj.rightTabInfo,separateOnUi);
        }
        returnObj.selectedTabObj = returnObj.leftTabInfo[0];
        returnObj.selectedTabIndex = 0

        $rootScope.communicationFieldsInfo = returnObj.rightTabInfo[0];
    }

    function getTabLabel(tObj){
        var retObj = tObj.map(function(o){return o.label});
        this.tabLabelName = retObj;
    }

    function selectDefaultTabs(actualObj){
        var entityTypeId = urlToCodeMapper[$routeParams.entityName];
        if (typeof localStorage !== 'undefined') {
            var x = JSON.parse(localStorage.getItem('defaultSelectedTab'));
            if(x){
                //Reset Template /clause shown tab as, PDF tab has been removed.
                //This code will run only once for every user
                var generalTabsMapper = {140:2212,138:2201};
                var shouldCheckEntity = Object.keys(generalTabsMapper).indexOf(""+entityTypeId)>-1;
                if(shouldCheckEntity){
                    var hasStorageForEntityType = x[entityTypeId] && x[entityTypeId].length;
                    if(hasStorageForEntityType){
                        var hasGeneralTab = x[entityTypeId].filter(o=>o.id==generalTabsMapper[entityTypeId]).length;
                        if(hasGeneralTab){
                            delete x[entityTypeId];
                            localStorage.setItem('defaultSelectedTab',JSON.stringify(x));
                        }
                    }
                }
                var j = _.remove(actualObj, function (o) {
                    return _.findIndex(x[entityTypeId],function(idx){return idx.id == o.id})>-1;
                });
                j = _.sortBy(j, function (item) {
                    return _.findIndex(x[entityTypeId],function(idx){return idx.id == item.id});
                });
            }
            actualObj = actualObj.splice(0,1);
            if(j){
                actualObj = _.concat(actualObj,j);
            }

        }else{
            actualObj = actualObj.splice(0,1);

        }
        return actualObj;

    }
    /************************************* End of separateCommentData function ****************************/

    /**separateButtons : function to separate workflow and nonworkflow buttons **/
    function separateButtons(btnList) {
        var nonMetaDataBtnList = ['Archive', 'OnHold', 'Restore', 'Activate'];
        /* Temporary movement of mentioned buttons in workflow button list */
        btnList = _.filter(btnList, function (o) {
            return o.type == 'button';
        });

        if(this.pageType=='show'){
            this.nonWorkFlowButtons = _.filter(btnList, function (o) {
                return o.buttonPosition == 20;
            });
            this.workFlowButtons = _.filter(btnList, function (o) {
                return o.buttonPosition == 10;
            });
            this.saveCommentButton = _.filter(btnList, function (o) {
                return o.buttonPosition == 30 && o.buttonType == 5;
            })[0];

            this.invoiceValidationStatusBtn = _.filter(btnList,function(o){
                return o.properties && o.properties.validationStatus;
            })[0];
            this.invoiceRegenerateBanner = _.filter(btnList,function(o){
                return o.properties && o.properties.regenerate;
            })[0];
            $rootScope.invoiceBtns = _.filter(btnList, function (o) {
                return o.buttonPosition == 40 && !o.properties.regenerate;
            });
        }else{
            this.workFlowButtons = [];
            this.nonWorkFlowButtons = btnList;
        }
        isInvoiceBtn.call(this);
        aeSecondaryBtns.call(this);
    }
    /***************************** End of separateButtons function ******************************/

    /**setVisiblityOfDocTree : function to show or hide doctree on page reload *****************/
    function setVisiblityOfDocTree(){
        let self = this;
        if(self.docViewerPage || self.surveyShowPage || (self.isNewCrudPage && self.isNewUX) || self.templateShowPage || !window.location.href.includes('show') || self.doNotOpenDocTreeByDefault){
            return false;
        }
    	let doctreePosInfo = sessionStorage.getItem('doctreePosition');
    	if(doctreePosInfo){
    		doctreePosInfo = JSON.parse(doctreePosInfo);
    		return doctreePosInfo.opened;
    	}else{
    		return true;
    	}
    }
    /******************************************************************************************/

    /** toggleDocTreeVisibilitySession : function to toggle value of doc tree opened state in session *****************/
    function toggleDocTreeVisibilitySession(flag){
        toggleBrowserStorageObjVal(flag, 'doctreePosition', sessionStorage);
    }

    function toggleBrowserStorageObjVal(flag, kName, storage) {
        flag = flag || false;
        storage = storage || localStorage;
        const kVal = storage.getItem(kName);
        let parsedKVal = {};
        if(!kVal) {
            parsedKVal.opened = flag;
        } else {
            parsedKVal = JSON.parse(kVal);
            parsedKVal.opened = flag;
        }
        storage.setItem(kName, JSON.stringify(parsedKVal));
    }
    /******************************************************************************************/

    /**separateSearchTableFieldInfo : function to separate searchTableFieldInfo *****************/
    function separateSearchTableFieldInfo(){
        advSearchService.mdTableFields = _.remove(returnObj.allleftTabInfo[0].fields, function (o) {
            return o.name == 'searchResults';
        });
    }
    /******************************************************************************************/
    /** btnClick : function to be perfomed on click of workflow and non-workflow buttons **/
    function btnClick(elem,btn) {
        localStorage.removeItem('updatedFields');
        $rootScope.showMergeButton = false;
        if($rootScope.forceRefresh){
            var message = '';
            if($rootScope.updatedFieldsArray && $rootScope.updatedFieldsArray.length){
                localStorage.setItem('updatedFields',JSON.stringify($rootScope.updatedFieldsArray));
                $rootScope.showMergeButton = true;
                message = 'This page is being updated. Please merge your changes.'
            } else {
                message = 'This page has been updated by another user. Please refresh to see updated page.';
            }

            Toaster.create(message);
            return;
        }
    	var isValid,
    		onClickProp = btn.properties["onClick"]["name"],
    		baseModel =  btn.baseModel ? btn.baseModel :'data',
    		modelType = 'none',
            self = this,
    		gFieldModel = $showPageService.getGFieldModel(btn.model, btn.name, modelType, baseModel );

    	if (elem.data("clientvalidation") == true || btn.properties?.isPartialEdit || $rootScope.aeDocShowPage) {
            var generalTab = $("show-page-tabs ul").first().find("li").first();

            const valid = validateDynamicForm(this,btn.properties?.isPartialEdit);
            if(!valid)
                return false;

            if($rootScope.createTemplateStructure){
                let playbookValid = validatePlaybook(this);
                if(!playbookValid){
                    return false;
                }
            }

            if(this.isAEProjectAction) {
                let configureProjectFieldsValid = validateConfigureProjectFields(this);
                if(!configureProjectFieldsValid){
                    $rootScope.$emit("Active index of breadcrumb", "createProjectBreadCrumb", 1);
                   return false;
                }

                let baseClauseTextsValid = !this.showBaseClauseTab || validateBaseClauseTexts(this);
                if(!baseClauseTextsValid){
                     $rootScope.$emit("Active index of breadcrumb", "createProjectBreadCrumb", 2);
                    return false;
                }
            }

            if(checkClientValidation.call(this,btn) == false){
                var self = this;
                $("#reqFieldsToggle").prop("checked", true);
                self.toggleAllReqFields();
                if(!generalTab.hasClass("active"))
                {
                    $timeout(function() {
                        if($rootScope.preSignature.crudPage)
                            $rootScope.$emit("Active index of breadcrumb", "createEditTemplateBreadCrumb",0);
                        else
                            generalTab.click();
                    }, 0);

                }
                return false;
    		}
        }
        if (elem.data("specificfieldvalidation") && elem.data("specificfieldvalidation") !== "") {
        	checkSpecificValidation.call(this,elem);
        }
        if ([true,"true"].indexOf(elem.data("donttouchthisbutton")) == -1 && (!btn.api || btn.api.indexOf("/comment") == -1 ) && !this.openFromShareWithConuterParty && !this.externalContract && !btn?.properties?.isPartialEdit) {
            this.selectedButton = btn.label;
        }
        switch (onClickProp) {
	        case "basicConfirmation":
	        	if(btn.message && !["","null"].includes(btn.message) && btn.properties["onClick"]["message"]){
                    const args = {
                        popupType: 'confirm',
                        str: btn.message,
                        yesCbFn: function(){
                            $showPageBtnClickService.basicConfirmation.call(this, btn, gFieldModel)
                        },
                        heading: intl_msg[25772],
                        noCbFn: 'successOnBothFalse',
                        yesName: intl_msg[24184],
                        noName: intl_msg[23731]
                    }
                    SirionUtils.openSirionDialogs(args);
                } else {
                    $showPageBtnClickService.basicConfirmation.call(this, btn, gFieldModel);
                }
	        	break;
	        case "deleteConfirmation":
                btn.properties.captcha = true;
	            $showPageBtnClickService.deleteConfirmation.call(this, btn, gFieldModel);
	            break;
	        case "directNonAjax":
	            $showPageBtnClickService.directNonAjax.call(this, btn);
	            break;
	        case "Download":
	            $showPageBtnClickService.downloadClick(btn);
	            break;
	        case "submitData": {
                if(btn.properties && btn.properties.captcha){
                    const baseMsg = btn.properties.onClick.message;
                    btn.properties.onClick.message = baseMsg + SirionUtils.getCaptcha(btn.properties);
                    btn.properties.onClick.title = intl_msg[24153];
                    $showPageBtnClickService.basicConfirmation.call(this, btn, gFieldModel);
                    btn.properties.onClick.message = baseMsg;
                } else {
                    if(window.waitForCDataUpdate) {
                        $timeout (() => {
                            $showPageBtnClickService.submitData.call(this, btn, true);
                        },600)
                    }else {
                        $showPageBtnClickService.submitData.call(this, btn, true);
                    }
                }
                this.showRawDataPopup.visible=false;
                this.rawDataCommentBox=false;
                this.showlineItemCommentBox=false;
                this.showlineItemPopup.visible=false;
                break;
            }
	        case "directAjax":
	        	$showPageBtnClickService.directAjax.call(this, btn);
	        	break;
        	case "undo":
                this.oldrevision();
                $timeout(function(){resizeInnerForm();},300);
                break;
            case "refreshTable":
                $showPageBtnClickService.refreshTable.call(this,btn);
                break;
            case "bulkActionData":
                $showPageBtnClickService.submitBulkActionData.call(this,btn);
                this.showlineItemCommentBox=false;
                this.showlineItemPopup.visible=false;
                break;
            case "delegationData":
                $showPageBtnClickService.submitDelegationData.call(this,btn);
                break;
            case "Reset":
                if(window.location.href.indexOf("search")===-1) {
                    this.data = angular.copy(this.originalDataFromServer);
                    if (!this.$$phase) {
                        this.$apply();
                    }
                    $("[name='slMet']").change();
                }
                break;
            case "closePopUp":
                if (this.currentOuterPopup) {
                    $(this.currentOuterPopup).dialog("close");
                    this.applyBasePageJson();
                } else {
                    if (this.myModelInstance) {
                        this.myModelInstance.close();
                    }
                    this.applyBasePageJson();
                }
                break;
            case "commentBox":
                this.openCommentDialog('commentBox' + gFieldModel.replace(/\./g, "_"), "comment");
                break;
            case "ajaxSpecificData":
                $showPageBtnClickService.ajaxSpecificData(this,btn);
                break;
    	}
    }
    /*************************** End of separateButtons function ******************************/
    /* *****************************************************************************************
    *********************************** END OF PUBLIC FUNCTION *********************************
    ********************************************************************************************/

    /*****************|| BEGINNING OF PRIVATE FUNCTIONS ||*********************/

    /** reorderCommentField : function for temporary rearrangement of comment section fields**/
    function reorderCommentField(commentsData) {
    	var reorderSeq = {
	        '11860': 30,
	        '86': 10,
	        '87': 40,
	        '88': 45,
	        '89': 50,
	        '41': 20
        };
        for (var i = 0; i < commentsData.length; i++) {
            commentsData[i].orderSeq = reorderSeq[commentsData[i].id.toString()];
        }
        commentsData = _.sortBy(commentsData, ['orderSeq']);
        return commentsData;
    }
    /************************** End of reorderCommentField function ************************/

    /** checkClientValidation : function be called on button click if the checkvalidation data property of button is true **/
    function checkClientValidation(btn){
        var self = this;
        self.IShouldSeeFieldErrors(true);
        var isValid = true;
        const isClauseSubmit = btn && btn.api == "/clause/edit";
        if (this.isIE() == 8) {
            isValid = this.validateIEEight();
        } else {
            isValid = $showPageService.getFormValidity.call(self, true,isClauseSubmit);
        }
        if (!isValid) {
            // Scroll screen to target element
            //$formService.scrollToElement("postError");
            if(!self.wfsModalOpen){
                $showPageService.scrollToElem("postError");
            }

            return false;
        }else{
        	return true;
        }
    }
    /***************************** End of checkClientValidation *******************************/

    /** checkSpecificValidation : function be called on button click if the specificfieldvalidation data property of button is not empty **/
    function checkSpecificValidation(elem){
    	var fieldsToValidate = elem.data("specificfieldvalidation").split(","),
    		isValid = true;
        this.IShouldSeeFieldErrors(true);

        if (this.isIE() == 8) {
            isValid = $scope.validateIEEight();
        } else {
            isValid = $showPageService.getFormValidity.call($scope, true, fieldsToValidate);
        }
        this.IShouldSeeFieldErrors(false);
        if (this.validity) {
            for (var i = 0; i < fieldsToValidate.length; i++) {
	            fieldsToValidate[i] = fieldsToValidate[i].trim();
	            isValid = this.validity[fieldsToValidate[i]];
	            if (typeof isValid !== 'undefined' && !isValid) {
	                var str = 'This fields required by this action are invalid, please correct them';
                    SirionUtils.openSirionDialogs({popupType: 'alert', str: str, heading: intl_msg[24153],yesCbFn: "cancel",yesName: "OK"});
	                return;
	            }
            }
        }
    }
    /********************************* End of checkSpecificValidation ****************************/


    function checkCommTabAdditionalFields(_rightInfoTabs,separateOnUi){
        var commTabFieldArr = [];
        var self = this;
        var ishideAddField;
        if(_rightInfoTabs[0].fields
            && _rightInfoTabs[0].fields[0]
            && _rightInfoTabs[0].fields[0].fields && _rightInfoTabs[0].fields[0].fields.length > 0 ){
            commTabFieldArr = _rightInfoTabs[0].fields[0].fields;
            if(separateOnUi){
                if(self.hideAdditionalCommentFieldsArr){
                    ishideAddField = _.intersectionWith(commTabFieldArr,self.hideAdditionalCommentFieldsArr,function(aval,oval){
                        return aval.id == oval;
                    });

                }
            }else{
                ishideAddField = _.filter(commTabFieldArr,function(o){return o.properties && o.properties.hideAdditionalField == true;});
            }
            if( ishideAddField && ishideAddField.length > 0){
                self.hideAdditionalFieldLabel =false;
            }
            else{
                self.hideAdditionalFieldLabel =true;
            }
         }
    };

    function getBtnClass(btnObj){
        var btnClass = '';
        if(btnObj){
            if(btnObj.api && btnObj.api.indexOf('/clone/') > -1   ){
                btnClass = 'Clone';
            }else if(btnObj.api && btnObj.api.indexOf('/delete') > -1 ){
                btnClass = 'delete';
            }else if(btnObj.requestType=='Print'){
                btnClass = 'Printer';
            }
        }
        return btnClass;

    }
    /* To hide Edit Delete And Clone From Workspace view
     * http://jira.sirionlabs.office/browse/SIR-195433
     * */
    function hideButtonForWorkspaceView(_button){
        var retval = false;
        var scope = $(".jx-nwfBtn").scope();
        if(!_button.properties.showCondition){
            if(isEditORCloneORDelete(_button)){
                if(scope && !scope.showWorkspaceView ){
                    retval = true;
                }
                else{retval = false;}
            }
            else{
                retval = true;
            }
        }
        return retval;
    }
    function isEditORCloneORDelete(btnObj){
        var retval = false;
        if(btnObj){
            if(btnObj.api && btnObj.api.indexOf('/clone/') > -1   ){
                retval = true;
            }else if(btnObj.api && btnObj.api.indexOf('/delete') > -1 ){
                retval = true;
            }else if(btnObj.api && btnObj.api.indexOf('/update/') > -1){
                retval = true;
            }
        }
        return retval;
    }
    /* findAllReqFields : function to find all required fields */
    function findAllReqFields(lfs){
        var temp = [];
        for(var i =0;i<lfs.length;i++){
            if(lfs && !lfs[i].properties.isSummaryGroup){
                temp = _.concat(temp,findRequiredFields(lfs[i].fields));
            }
        }
        return temp;
    }

    /* function to find all required fields */
    function findRequiredFields(fs){
        var temp,temp1 = [];
        var x = _.filter(fs,function(o){
            if(o.hasOwnProperty('fields')){
                temp = findRequiredFields(o.fields);
                temp1 = _.concat(temp1,temp);
            }else{
                if(o.hasOwnProperty('validations') && _.findIndex(o.validations,function(obj){return obj.type == 'required'}) > -1){
                    if(o.properties.hideAdditionalField){
                        o.properties.hideAdditionalField = !o.properties.hideAdditionalField;
                    }
                }
                return o.hasOwnProperty('validations') && _.findIndex(o.validations,function(obj){return obj.type == 'required'}) > -1;
            }
        });
        temp1 = _.concat(x,temp1);
        return temp1;
    }

    /* function to find all non-required fields */
    function findNonRequiredFields(fs){
        var temp,temp1 = [];
        var x = _.filter(fs,function(o){
            if(o.hasOwnProperty('fields') && o.type != 'dynamicTable' ){
                temp = findNonRequiredFields(o.fields);
                temp1 = _.concat(temp1,temp);

            }else{
                return (!o.hasOwnProperty('validations')|| (o.hasOwnProperty('validations') && _.findIndex(o.validations,function(obj){return obj.type == 'required'}) < 0));
            }
        });
        temp1 = _.concat(x,temp1);
        return temp1;
    }

    /* function to create group of required and non-required fields */
    function createGroupOfFields(lfs){
        var temp = {'rf':{},'nrf':{}};
        for(var i =0;i<lfs.length;i++){
            if(!lfs[i].properties.isSummaryGroup){
                temp['rf']['fieldset_'+lfs[i].id] = [];
                temp['rf']['fieldset_'+lfs[i].id] = _.concat(temp['rf']['fieldset_'+lfs[i].id],findRequiredFields(lfs[i].fields));
                temp['nrf']['fieldset_'+lfs[i].id] = [];
                temp['nrf']['fieldset_'+lfs[i].id] = _.concat(temp['nrf']['fieldset_'+lfs[i].id],findNonRequiredFields(lfs[i].fields));
            }
        }
        return temp;
    }
    /* function to hide non required fields */
    function hideNonReqFields(scope,formFieldGroups){
        if(!scope.toggleAllGroupsVal){
            scope.toggleAllGroups();
        }
        for(var j in formFieldGroups.nrf ){
            if(formFieldGroups.rf.hasOwnProperty(j) && !formFieldGroups.rf[j].length  && !angular.element('.'+j).find('.errorClass').length  && ! angular.element('.'+j).hasClass('hidden')){
                angular.element('.'+j).addClass('hidden');
                angular.element('.'+j).addClass('hidden-nrf');

            }else{
                for(var itr =0;itr< formFieldGroups['nrf'][j].length;itr++){
                    var element = angular.element('#elem_'+formFieldGroups['nrf'][j][itr]['id']);
                    const fieldSet = element.closest('fieldset');
                    if(!element.find(".errorClass").length){
                        element.parents('label').addClass('hidden-nrf').addClass('hidden');
                        if(element.hasClass("tableScroll") ){
                            element.addClass("hidden-nrf").addClass("hidden");
                        }
                            var totalLength = fieldSet.find(".coveringParent:visible").length + fieldSet.find(".tableScroll:visible").length;
                        if(!totalLength) {
                          fieldSet.addClass('hidden-nrf').addClass('hidden');
                        }
                    }else if(element.find(".errorClass").length){
                        if(element.parents('label').length && element.parents('label').find('.hidden')) {
                            element.parents('label').removeClass('hidden-nrf').removeClass('hidden');
                            fieldSet.removeClass('hidden-nrf').removeClass('hidden');
                        } else if(element.hasClass("tableScroll")){
                            element.removeClass('hidden-nrf').removeClass('hidden');
                            fieldSet.removeClass('hidden-nrf').removeClass('hidden');
                        }
                    }
                }
            }
        }
    }

    function getToolTip(x){
        const toolTip = (x.api.indexOf('/baseInvoice/uploadinvoicecopy') !=-1)
            ? ''
            : ((x.properties.enable) ? (intl_msg[31032] || 'Sirion will create an official invoice document for you.') : (intl_msg[31033] || 'Invoice generation is in progress.Please wait for some time.'));
        return toolTip;
    }

    function isInvoiceBtn() {
        var self = this;
        var invoiceBtnArr = [];
        $rootScope.invoiceCopyActionBtns = [];
        if(!(self.nonWorkFlowButtons && self.nonWorkFlowButtons.length))
            return ;
        $rootScope.invoiceBtns.findIndex(function (x) {
            if (x && x.properties) {
                if (x.properties.showInHeader) {
                    x.toolTip = getToolTip(x);
                    invoiceBtnArr.push(x);
                } else {
                    $rootScope.invoiceCopyActionBtns.push(x);
                }
            }
        });
        this.invoiceBtnArr = invoiceBtnArr;
        if($rootScope.invoiceCopyActionBtns.length) {
            $rootScope.invoiceName = self.data && self.data.invoiceCopyName ? self.data.invoiceCopyName.values : null;
            self.setInvoiceDocIcons($rootScope.invoiceName);
            angular.element(".inv_Copy_Action").css("display","inline-block");
            if($location.search()._inv) {
                $timeout(function () {
                    angular.element(".inv_Copy_Action").find(".pdf-link").trigger('click');
                    // $location.search('_inv', null);
                },10)
            }
        } else { angular.element(".inv_Copy_Action").css("display","none");}
    }

    function aeSecondaryBtns() {
        let self = this;
        if(self.onlyDoc || self.isAEContractPage){
            if(!self.secondaryActions){
                self.secondaryActions = {};
            }
            self.secondaryActions.WfDD = self.workFlowButtons && self.workFlowButtons.filter(b=>b.name!="Undo");
            self.secondaryActions.btnClickAE = self.btnClick;
        }
    }

    function validateDynamicForm(scope,isPartialEdit = false) {
        if(scope.globalData.dynamicFormId && !scope.rawDataCommentBox ) {
            let response = window.sarc.channelBroadcast("reactDynamicForms",{actionType:"validate",workFlowBtnClicked:true,isPartialEdit},`dfSubscriptions_${scope.globalData.dynamicFormId}`);
            if(response.length > 0 && !response[response.length -1].res) {
                dataManipulationService.fetchTextAreaValues(scope.data, window.htmlEditorList,null,scope,true);
                return false;
            }
        }
        return true;
    }

    function validateBaseClauseTexts(scope) {
        let baseClauseTextData = _.get(scope,'data.baseClauseTexts.values');     
        if(_.get(baseClauseTextData,'length')){
            let response = window.sarc.channelBroadcast("AEProjectAction",{actionType:"validateBaseClauseTexts", payload:{baseClauseTextData : baseClauseTextData}},'AEProjectSubscription');
            if(_.get(response, "length") && !response[0].res){
                return true;
            }
            return false;
        } else {
            return true;
        }
    }

    function validateConfigureProjectFields(scope) {
        let projectGroupsData = _.get(scope,'data.projectFields.values');
        if(_.get(projectGroupsData,'length')){
            return true;
        } else {
            window.sarc.channelBroadcast("ValidateConfigureFields",{actionType:"validateAEProjectData",payload:{projectFields :_.get(scope,'data.projectFields.values')}},'AEProjectSubscription');
            return false;
        }
    }

    function validatePlaybook(scope){
        let categories = _.get(scope,'data.playbookClauseCategories.values');
        let playbookLoaded =  $("#playbook-main").children().length;
        if(playbookLoaded &&  _.get(categories,'length')){
            let response = window.sarc.channelBroadcast("contractPlayBook",{actionType:"validate",payload :{categories:categories}},'contractPlayBookSubscription');
            if(_.get(response, "length") && !response[0].res){
                return true;
            }
            return false;
        } else {
            return true;
        }


    }

    function mountAnalyticsTab(id){
        let mountAt = '#tab_' + id;
        let propsToPass = {
            projectId:$rootScope.data.id.values,
            mountAt
        }
        var interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if ($rootScope.showAnalytics) {
                    window.reactComponents.mountDynamicComponent(mountAt, "Analytics",propsToPass);
                }
            }
        }, 10)
    }

    function shouldShowPerformance() {
        return returnObj.rightTabInfo.some(item => item.shortName);
    }

    /*****************************|| End of Private Functions ||*********************************/
}]);
})();
//***************************** End of showPage2DataTransformationService ***********************************//
